import type { TableLayoutDTO } from '@tempo-io/roadmap-dto';
import type { DependencySectionValue } from '@/features/item-panel/components/tabs/dependencies/lib/types';

export const DEPENDENCY_DROPDOWN_ITEM_LIMIT = 50;
export const MIN_NAME_COLUMN_WIDTH = 160;

// Ephemeral layout for the embedded ItemsTable: only the name column is
// layout-driven (via groupingColDef); every other column is hand-built in
// buildColumns, so visualizationId/itemLevelId are never persisted or read.
export const DEPENDENCY_TABLE_LAYOUT: TableLayoutDTO = {
  visualizationType: 'table',
  visualizationId: 1,
  itemLevelId: 1,
  theme: 'standard',
  density: 'compact',
  columns: [{ type: 'name', customFieldId: null }],
};

// Matches the header look of the old sui-tablelayout table (uppercase, semibold,
// secondary-grey) since ItemsTable's default MUI header styling doesn't apply it.
// The tree-data grouping (name) column also keeps a right border/divider even with
// showColumnVerticalBorder/showCellVerticalBorder off, since MUI treats it like a
// pinned column boundary — strip it explicitly by field. Excludes the `--sorted`
// header state so it still gets the theme's accent-blue sort-highlight shadow.
export const DEPENDENCY_TABLE_SX = {
  '& .MuiDataGrid-columnHeaderTitle': {
    textTransform: 'uppercase',
    fontWeight: 600,
    fontSize: '0.75rem',
    color: 'var(--color-text-neutral-secondary)',
  },
  '& .MuiDataGrid-columnHeader[data-field="__tree_data_group__"]:not(.MuiDataGrid-columnHeader--sorted), & .MuiDataGrid-cell[data-field="__tree_data_group__"]':
    {
      borderRight: 'none',
      boxShadow: 'none',
    },
} as const;

export const DEFAULT_OPEN_SECTIONS: DependencySectionValue[] = ['predecessors', 'successors'];
